export const LOGIN_RESPONSE = "LOGIN_RESPONSE";
export function loginResponse(response) {
    return {
        type: LOGIN_RESPONSE,
        response: response,
    };
}
